import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ServiceRecordState } from "./model";

let state: ServiceRecordState = {
  serviceRecords: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ServiceRecordState, RootStateType>;
